import { createModalContext, useModalState } from '@/common/app/modal'
import { Widget } from '@/common/model/recommend/widget'
import { ChildProps } from '@/common/util/props'

import WidgetDesignModal from '@/components/container/modal/widget/design/WidgetDesignModal'

interface WidgetDesignModalState {
  widget: Widget
}

const defaultValue = {
  widget: null as unknown as Widget
}

export const WidgetDesignModalContext = createModalContext<WidgetDesignModalState>(defaultValue)

const WidgetDesignModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<WidgetDesignModalState>(defaultValue)
  return (
    <WidgetDesignModalContext.Provider value={state}>
      {children}
      <WidgetDesignModal />
    </WidgetDesignModalContext.Provider>
  )
}

export default WidgetDesignModalProvider
